<template>
  <div class="ios-glass-page">
    <!-- 1. 动态背景光斑 -->
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
      <div class="blob blob-3"></div>
    </div>

    <!-- 2. 头部卡片 -->
       <!-- 顶部导航 (传入透明背景以融合页面) -->
      <!-- :projectName="teacherTitleInfo.schoolName"  -->
    <ProjectHeader 
      ref="headerRef" 
      class="glass-header"
      style="margin:10px 0 30px 0;"
    />
    <!-- <div class="glass-container header-card">
      <div class="header-content">
        <div class="avatar-base">
          <van-icon name="shop-o" size="28" color="#007AFF" />
        </div>
        <div class="info-text">
          <h2 class="school-name">{{ teacherTitleInfo.schoolName || '正在加载...' }}</h2>
          <span class="user-role">教师端工作台</span>
        </div>
      </div>
    </div> -->

    <!-- 3. 菜单分组循环 -->
    <div v-for="(group, index) in menuList" :key="index" class="glass-container">
      <h3 class="panel-title">{{ group.menuType }}</h3>
      
      <div class="grid-box">
        <div 
          class="grid-item" 
          v-for="item in group.children" 
          :key="item.id" 
          @click="goPage(item)"
        >
          <!-- 图标容器：白色磨砂底座 -->
          <div class="icon-base">
            <van-icon 
              :name="item.icon" 
              :color="item.color" 
              size="26" 
            />
          </div>

             <!-- iOS 风格彩色图标底座 -->
            <!-- <div class="icon-base" :style="{ background: item.color }">
              <van-icon :name="item.icon" size="18" color="#fff" />
            </div> -->
          <span class="grid-text">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <!-- 4. 底部版本号 -->
    <div class="footer-info">
      <span class="version-pill">Version: LM-0S-JX</span>
    </div>
  </div>
</template>

<script>
import { checkPersonType } from "@/api/bind";
import { getTeacherInfoByOpenId } from "@/api/teacher";
import { getLocal } from "@/utils/cookie";
import wx from 'weixin-js-sdk';
import ProjectHeader from "@/components/ProjectHeader.vue";


// 引入 Vant Icon (如果你是全局引入可以省略这行，局部引入需要解构)
// import { Icon } from 'vant';

export default {
  name: "TeacherIndex",
  components: {
    ProjectHeader
    // [Icon.name]: Icon, 
  },
  data() {
    return {
      teacherTitleInfo: {},
      // 重构后的菜单列表：使用 icon 和 color 代替 url
      menuList: [
        {
          menuType: '注册绑定',
          children: [
            // color: 仿 iOS 蓝、绿、靛青
            { id: 1, name: '管理员注册', icon: 'manager-o', color: '#007AFF' },
            { id: 2, name: '班级制证', icon: 'idcard', color: '#5856D6' },
            { id: 3, name: '新增教师', icon: 'friends-o', color: '#34C759' },
            { id: 4, name: '多学校绑定', icon: 'user-o', color: '#34C759' },
            { id: 5, name: '个人中心', icon: 'user-o', color: '#34C759' },
          ]
        },
        {
          menuType: '成绩管理',
          children: [
            // color: 仿 iOS 橙、红、黄
            { id: 1, name: '扫码登记', icon: 'scan', color: '#FF9500' },
            { id: 0, name: '班级登记', icon: 'records', color: '#FF3B30' },
            { id: 2, name: '成绩查询', icon: 'chart-trending-o', color: '#FF2D55' },
            { id: 3, name: '体测看板', icon: 'desktop-o', color: '#AF52DE' },
            { id: 4, name: '阳光跑成绩', icon: 'fire-o', color: '#FFCC00' },
          ]
        },
        {
          menuType: '设备管理',
          children: [
            // color: 仿 iOS 灰、蓝灰
            { id: 1, name: '电源开关', icon: 'bulb-o', color: '#8E8E93' },
            { id: 5, name: '设备遥控器', icon: 'setting-o', color: '#64D2FF' },
          ]
        },
      ],
    };
  },
  created() {
    this.checkPersonType();
  },
  methods: {
    checkPersonType() {
      checkPersonType({ openId: getLocal('openId') }).then(res => {
        if (+res.data.body == 8 || +res.data.body == -1) {
          this.$router.push({ path: 'parentReg', query: { identity: 'teacher', backUrl: '/teacher' } });
        } else {
          getTeacherInfoByOpenId({ wxmpOpenid: getLocal('openId') }).then(res => {
            this.teacherTitleInfo = res.data.body || {};
            sessionStorage.setItem('teacherTitleInfo', JSON.stringify(this.teacherTitleInfo));
            // 更新表头
            this.$refs.headerRef.updateCurrentSchool(this.teacherTitleInfo)
            this.init();
          });
        }
      });
    },
    init() {
      try {
        const infoStr = sessionStorage.getItem('teacherTitleInfo');
        if (infoStr) {
          let schCode = JSON.parse(infoStr).schoolCode;
          let phoneNumber = JSON.parse(infoStr).phoneNumber;
          if (schCode == 'hbswcsyzx') {
            this.menuList.push({
              menuType: '智慧体育助手',
              children: [
                { id: 1, name: '客服反馈', icon: 'service-o', color: '#5AC8FA' },
                { id: 2, name: '体育考勤', icon: 'clock-o', color: '#30B0C7' },
              ]
            });
          }

            if (schCode == 'LMWZ') {
            this.menuList.push({
              menuType: '工具中心',
              children: [
                { id: 1, name: '举报记录', icon: 'service-o', color: '#5AC8FA' },
                { id: 2, name: '审核中心', icon: 'sign', color: '#5AC8FA' },
                { id: 3, name: '长跑发令', icon: 'bullhorn-o', color: '#5AC8FA' },
                { id: 4, name: '测试场景', icon: 'points', color: '#5AC8FA' },
             



              ]
            });
          }
          


           if (phoneNumber == '13814032671'||phoneNumber == '18226351321'||phoneNumber == '15951919151') {
            this.menuList?.forEach(el=>{
              if (el.menuType=="设备管理") {
                this.$set(el,"children",[
                   { id: 1, name: '电源开关', icon: 'bulb-o', color: '#8E8E93' },
                   { id: 5, name: '设备遥控器', icon: 'setting-o', color: '#64D2FF' },
                  { id: 2, name: '新华数据统计', icon: 'notes-o', color: '#30B0C7' },
                ])
              }
            })
        
          }


          


        }
      } catch (e) {
        console.error("Init Error:", e);
      }
    },
    goPage(val) {
      // 路由映射表
      const pageMap = {
        '学生绑定': '/studentBind',
        '新增教师': '/addTeacher',
        '多学校绑定': '/addLogin?identity=teacher&backUrl=%2Fteacher',
        '测训准考证': '/admissionTicket',
        '个人中心': '/informationCenterTeacher',
        
        '家庭作业': '/homework',
        '班级登记': '/classReporting',
        '班级制证': '/teacherAddFaceIn',
        '成绩查询': '/teacherScore',
        '管理员注册': '/teacherAdminFace',
        '体测看板': '/whiteBook',
        '阳光跑成绩': '/teacherSunrunScore',
        '电源开关': '/powerSwitch',
        '项目控制': '/deviceControl',
        '跳跳视讯切换': '/deviceControlVideo',
        '设备遥控器': '/deviceControlMgt',
        '户外跑设置': '/outdoorRunning',
        '客服反馈': '/messageBoardMgt',
        '体育考勤': '/teacherAttendanceCall',
        '新华数据统计': '/whitePage/dinfo',
        '举报记录': '/ReportManagement',
        '审核中心': '/AuditCenter',
        '长跑发令': '/RaceCommandManager',
        '测试场景': '/PETeacherWorkspace',
   


        
      };

      if (val.name === '扫码登记') {
        this.onScanClick();
        return;
      }

      const url = pageMap[val.name];
      if (url) {
        this.$router.push({ path: url });
      } else {
        this.$toast({ message: "暂未开放，敬请期待", position: 'bottom' });
      }
    },
    onScanClick() {
      let that = this;
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function (res) {
          var result = res.resultStr;
          let stringList = result.split('&&');
          if (stringList.length !== 2) {
            that.$notify({ type: "danger", message: '请扫描本系统孩子二维码！' });
            return;
          }
          that.$router.push({ path: 'teacherReporting/reportingList', query: { snCode: stringList[0], schoolCode: stringList[1] } });
        },
        error: function (res) {
          console.error(res);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/* ---------------- 页面容器 ---------------- */
.ios-glass-page {
  min-height: 100vh;
  width: 100%;
  /* iOS 15 风格壁纸渐变 */
  // background: linear-gradient(135deg, #e0f7fa 0%, #f0f4f8 100%);
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", Helvetica, Arial, sans-serif;
  padding: 16px;
  box-sizing: border-box;
  overflow-y: auto;
}

/* ---------------- 动态背景光斑 ---------------- */
/* 背景装饰球（增加氛围感） */
.background-blobs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  
  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.6;
  }
  .blob-1 {
    width: 300px;
    height: 300px;
    background: #a0c4ff;
    top: -50px;
    left: -50px;
    animation: float 8s infinite ease-in-out;
  }
  .blob-2 {
    width: 250px;
    height: 250px;
    background: #b9fbc0;
    bottom: -50px;
    right: -50px;
    animation: float 8s infinite ease-in-out reverse;
  }
}

// @keyframes float {
//   0%, 100% { transform: translate(0, 0); }
//   50% { transform: translate(20px, 30px); }
// }

/* ---------------- 通用毛玻璃卡片 ---------------- */
.glass-container {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.15); /* 提高白底透明度，更干净 */
  backdrop-filter: blur(12px) ;
  -webkit-backdrop-filter: blur(12px) ;
  
  
  border-radius: 20px;
  padding: 16px;
  margin-bottom: 20px;



  border: 1px solid rgba(255, 255, 255, 0.8); 
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15); 
}

/* ---------------- 头部样式 ---------------- */
.header-card {
  margin-top: 10px;
  display: flex;
  align-items: center;

  .header-content {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .avatar-base {
    width: 48px;
    height: 48px;
    /* 纯白底座 */
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
    margin-right: 12px;
    border: 1px solid rgba(255,255,255,0.6);
  }

  .info-text {
    display: flex;
    flex-direction: column;

    .school-name {
      margin: 0;
      font-size: 17px;
      font-weight: 600;
      color: #1c1c1e;
    }

    .user-role {
      font-size: 12px;
      color: #8e8e93;
      margin-top: 3px;
    }
  }
}

/* ---------------- 菜单网格样式 ---------------- */
.panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #8e8e93; /* iOS 分组标题色 */
  
  margin: 0 0 12px 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.grid-box {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -4px;
}

.grid-item {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.2s;
  
  /* 按下效果 */
  &:active {
    transform: scale(0.92);
    opacity: 0.8;
  }

  .icon-base {
    width: 46px;
    height: 46px;
    background: #ffffff;
    /* 仿 App Store 图标圆角 */
    border-radius: 12px; 
    display: flex;
    align-items: center;
    justify-content: center;
    /* 细腻的阴影 */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0,0,0,0.02);
    margin-bottom: 8px;
    border: 1px solid rgba(255, 255, 255, 0.8);
  }

  .grid-text {
    font-size: 11px;
    color: #1d1d1f;
    text-align: center;
    line-height: 1.3;
    padding: 0 2px;
    /* 限制两行 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

/* ---------------- 底部样式 ---------------- */
.footer-info {
  text-align: center;
  margin-top: 24px;
  margin-bottom: 8px;
  z-index: 1;
  position: relative;

  .version-pill {
    display: inline-block;
    padding: 3px 10px;
    font-size: 10px;
    color: #aeaeb2;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
  }
}
</style>